import { Component, OnInit, ViewChild, Input } from '@angular/core'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { NoteService } from '../../shared/services/note.service';
import { Note } from '../../shared/models/Note';
import { NoteFormComponent } from '../../shared/components/modals/note-modal/note-form.component';
import { AuthorizeService } from '../../../api-authorization/authorize.service';
 
@Component({
  selector: 'app-notes', 
  templateUrl: './notes.component.html'
})

export class NotesComponent implements OnInit {  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<Note>();
  displayedColumns: string[] = ['actions', 'description', 'createdBy', 'createDate'];
  public userName: string; 
  private _contentId; // private property _item
  private _contentType; // private property _item
  private _total = 0; // total number of pages

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private noteService: NoteService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService,
    private authorizeService: AuthorizeService
  ) { }
   


  // use getter setter to define the property
  get contentId(): any {
    return this._contentId;
  }

  @Input()
  set contentId(val: any) { 
    this._contentId = val; 
  } 

  @Input()
  set total(val: any) {
    this._total = val;
  }

  get total(): any {
    return this._total;
  }

  // use getter setter to define the property
  get contentType(): any {
    return this._contentType;
  }

  @Input()
  set contentType(val: any) { 
    this._contentType = val;
  } 
   
  // on load
  ngOnInit() {
    // get current user
    this.authorizeService.getUser().subscribe(result => {
      this.userName = result.name;
    });

    this.getRecords(this.contentId, this.contentType, this.total);
  }

  // get records
  getRecords(contentId: number, contentType: number, total: number): void {
      this.noteService.getAll(contentId, contentType, total).subscribe(result => { 
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 

      }, error => console.error(error));
  }

  // open add form 
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(NoteFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add Note';

    let model: Note = {
      id: 0, contentId: this.contentId, contentType: this.contentType, description: '', createDate: '', createdBy: ''
    };

    modalRef.componentInstance.inputModel = model;

    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getRecords(this.contentId, this.contentType, this.total);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  } 

  // delete item
  deleteItem(id: number) { 
    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {  
        if (confirmed) {
          this.noteService.delete(id).subscribe(() => {
              this.showNotification('The note has been deleted successfully!', 'Okay!');
              this.getRecords(this.contentId, this.contentType, 0);
            });
          }
        }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }

  //// edit item
  editItem(model: Note) {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(NoteFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Edit Note';
    modalRef.componentInstance.inputModel = model;

    // modal result
    modalRef.result.then((result) => { 
      if (result) {
        this.getRecords(this.contentId, this.contentType, this.total);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );  
  }
    
  //// filter locations
  //applyFilter(event: Event) {
  //  const filterValue = (event.target as HTMLInputElement).value;
  //  this.dataSource.filter = filterValue.trim().toLowerCase();
  //}
   
  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  } 
}

